import { apiSlice } from '../../../api/apiSlice';
import { ALL_SCORECARD_DISPUTES } from '../../../constants';

export const disputeSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAllScorecardDisputes: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: ALL_SCORECARD_DISPUTES,
                    params: { year, month, scorecardVersionId },
                };
            },
        }),
    }),
});

export const { useGetAllScorecardDisputesQuery,
 } = disputeSlice;
